import { common_v1_ObjectMeta } from '@antimatterhq/asl-api-ts-v1';

const CLIENT_ID = `asl-web/${import.meta.env.VITE_VERSION}`;

/**
 * Sets the clientOfOrigin field on a resource's metadata
 * @param resource - The resource object that has a metadata field
 * @returns The resource with updated metadata
 */
export function setClientOfOrigin<
  T extends { metadata?: common_v1_ObjectMeta | null },
>(resource: T): T {
  if (!resource.metadata) {
    return {
      ...resource,
      metadata: {
        name: '',
        clientOfOrigin: CLIENT_ID,
      },
    };
  }

  return {
    ...resource,
    metadata: {
      ...resource.metadata,
      clientOfOrigin: CLIENT_ID,
    },
  };
}
